<template>
  <div class="box">
    <h4>联系我们</h4>
    <div class="main">
      <div class="common">
        <p class="title">客户服务（支付问题、功能故障、投诉建议、使用帮助）：</p>
        <div class="info">
          <ul>
            <li>
              <p>电子邮件：</p>
              <p>service@iartschool.com</p>
            </li>
            <li>
              <p>联系电话 ：</p>
              <p>4009-260-658</p>
              <p>18167176677（微信同号）</p>
            </li>
            <li>
              <p>客服提醒：</p>
              <p>为了更快帮您解决问题，请在邮件中留下电话、爱艺术+账号、订单号、截图等信息，并尽可能详细的描述问题。</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="common">
        <p class="title">联系地址：杭州市西湖区转塘街道凤凰创意大厦3号楼东楼2单元601-604室</p>
        <div class="info">
          <ul>
            <li>
              <p>邮政编码：</p>
              <p>310000</p>
            </li>
            <!-- <li>
                         <p>公司地址：</p>
                         <p >杭州市西湖区转塘街道凤凰创意大厦3号楼东楼2单元601-604室</p>
            </li>-->
          </ul>
        </div>
      </div>
      <div class="map" @click="go()">
        <img src="@/assets/img/addressLogo.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    go() {
      window.open(
        "https://uri.amap.com/marker?position=120.0682300000,30.1399400000&name=杭州市西湖区转塘街道凤凰创意园3B"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  background: #fff;
  border-radius: 10px;
  height: 100%;
  padding: 24px 16px;
  min-height: 600px;
  h4 {
    font-size: 24px;
    line-height: 30px;
    color: #333;
  }
  .main {
    margin-top: 24px;
    .common {
      margin-bottom: 24px;
      .title {
        font-size: 18px;
        line-height: 24px;
        color: #333333;
        margin-bottom: 30px;
      }
      li {
        p {
          margin-top: 6px;
          font-size: 14px;
          line-height: 24px;
          color: #666666;
        }
        p:first-child {
          font-size: 16px;
          line-height: 24px;
          color: #333333;
        }
      }
      li:not(:last-child) {
        margin-bottom: 20px;
      }
    }
    .map {
      img {
        border-radius: 10px;
        overflow: hidden;
        width: 100%;
        height: 300px;
        object-fit: cover;
        cursor: pointer;
      }
    }
  }
}
</style>